﻿window.cObjetComSmsRecuMetier = function(objet) {
    var Me = this;
    this.data = objet.data;
    this.objet = objet;

    this.mGetLibBase = function () { return "sms reçu"; }
    this.mGetAttributBase = function () { return "l'" }
    this.mGetNewLib = function () { return "Nouveau sms"; }
    this.mGetLib1 = function (option) {
        var txt = ""
        if (typeof objet.data != 'undefined') { txt = ((objet.data.body_txt) ? objet.data.body_txt : "") }
        else {
            txt = "sms"
        }
        if (typeof option !='undefined' && typeof option.callBack != 'undefined') { option.callBack(txt) }
        else { return txt }
    }
    this.mGetLib2 = function () {
        return ""
    }

    this.mGetRadiusImage = function () { return "0" }
    this.mGetResume = function () {
        var txt = "";
        return txt;
    }

    this.mGetIcone = function (dataTemplate) {
        var $Icone = $("<i class='fas fa-comment-sms' style='position:relative'></i>");
        var $ssIcone = $("<i class='fas' style='position:absolute;bottom:-5px;right:-8px;opacity:1;font-size:65%;color:" + theme.backgroundcolorAccent + "'></i>")
        $ssIcone.addClass("fa-circle-chevron-left");
        if ($ssIcone) $ssIcone.appendTo($Icone)
        $Icone.attr("title", "SMS reçu")
        //$("<div/>").appendTo("body").dxCtrlTooltipHoverTarget({ target: $Icone, position: "bottom", contentTemplate: function (contentElement) { contentElement.text("SMS reçu") } })
        return $Icone
    }

    this.contentTemplatePopup = function (contentElement, option) {
        contentElement.empty();
        dxCtrl = $("<div style='height:100%;width:100%;'/>").appendTo(contentElement).dxCtrlContentSmsEnvoi({
            bddCtrl: Me.objet.bddRef,
            data: objet.data
        }).dxCtrlContentSmsEnvoi("instance")
    }

    this.alignItemGrid = "right"
    this.itemTemplateGrille = function (contentElement, dataTemplate, type, option) {

        if (dataTemplate.nouveau == "1") {
            contentElement.addClass("nouveauemail")
        }
        //contentElement.css("opacity", "0.8")
        var $Table = $("<table style='table-layout:fixed;width:100%;text-align:right;'/>").appendTo(contentElement)
        var $Tr = $("<tr/>").appendTo($Table)

        var $TdObjetBody = $("<td style='width:75%;overflow:hidden;text-overflow:ellipsis;padding:0 3px;'/>").appendTo($Tr)
        var bodyTxt = $("<div/>").html(dataTemplate.body_txt).text().replace(/\u00A0/g, '')
        if (type == "Détails") {
            $TdObjetBody.css("font-weight", "500")
            var $Tr2 = $("<tr/>").appendTo($Table)
            var $Td = $("<td style='width:100%;padding:0 3px;white-space:normal;font-style:italic;font-size:90%;line-height:1.3;opacity:0.7;padding-top:5px;' colspan='6'></td>").appendTo($Tr2)
            var $Div = $("<div class='ellipsismultiligne3'></div>").appendTo($Td)
            $Div.text(bodyTxt.decoupe())
        } else {
            bodyTxt = bodyTxt.substring(0, 300)
            $("<span> &bull; <i style='opacity:0.7;'>" + bodyTxt + "</i></span>").appendTo($TdObjetBody)
        }

        var $TdEmailExp = $("<td style='width:25%;overflow:hidden;text-overflow:ellipsis;padding:0 3px;font-size:90%;'></td>").appendTo($Tr)
        var tel = new cTelephone(dataTemplate.tel_code_pays_expediteur,dataTemplate.tel_num_expediteur)
        var lib = ((typeof dataTemplate.nom_usuel_expediteur != 'undefined' && dataTemplate.nom_usuel_expediteur != null && dataTemplate.nom_usuel_expediteur.length > 0) ? dataTemplate.nom_usuel_expediteur + " [" + tel.mGetValueMiseEnForme() + "]" : "[" + tel.mGetValueMiseEnForme() + "]")
        $TdEmailExp.html(" &bull; " + ((parseInt(dataTemplate.nbdest) > 1) ? "(" + dataTemplate.nbdest + ") " : "") + "<a href='javascript:void(0)'>" + lib + "</a>")
        $TdEmailExp.attr("title", lib)

        var $TdDest = $("<td style='width:25px;padding:0 3px;height:1px;'/>").appendTo($Tr)
        if (dataTemplate.id_table_expediteur != null) {
            $("<div style='width:100%;height:100%;border-radius:50%;'/>").appendTo($TdDest).dxCtrlImgSimpleStrConUti({
                bddCtrl: objet.bddRef,
                idTable: dataTemplate.id_table_expediteur,
                id: dataTemplate.id_expediteur,
                text: dataTemplate.nom_usuel_expediteur
            })
        }

        var $TdUti = $("<td style='width:25px;padding:0 3px;height:1px;'/>").appendTo($Tr)
        $("<div style='width:100%;height:100%;border-radius:50%;'/>").appendTo($TdUti).dxCtrlImgSimpleStrConUti({
            bddCtrl: objet.bddRef,
            idTable: objet.bddRef.getObjet("utilisateur").mGetTable().id_table,
            id: dataTemplate.id_utilisateur,
            text: objet.bddRef.getObjet("utilisateur", dataTemplate.id_utilisateur).mGetLib1()
        })

    }
    this.itemTemplateGrillePlus = function (contentElement, dataPlus) {
        $("<span style='' title='Créé le " + dataPlus.date_reception.toFrenchDateTime() + "'><i class='fas fa-envelope-open dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + dataPlus.date_reception.toDateIlya(true) + "</span>").appendTo(contentElement)
    }

    this.mGetWidthPopup = function () { return 680 }
    this.mGetShowTitlePopup = function () { return false }

    this.isPopupFullScreen = true
    //this.mShowPopup = function (optionPopup) {
    //    page.mAddPopup(objet.data)
    //}

}